import { ReviewSectionComponent } from './review-section.component';

export enum SectionIdentifier {
  PersonalData_ConnectionAddress = 'PersonalData_ConnectionAddress',
  PersonalData_ConnectionUser = 'PersonalData_ConnectionUser',
  PersonalData_Subscriber = 'PersonalData_Subscriber',
  PersonalData_Technician = 'PersonalData_Technician',
  PersonalData_InstallerCompany = 'PersonalData_InstallerCompany',

  TechnicalData_BaseData = 'TechnicalData_BaseData',
  TechnicalData_BaseData_Power = 'TechnicalData_BaseData_Power',
  TechnicalData_BaseData_Gas = 'TechnicalData_BaseData_Gas',
  TechnicalData_BaseData_Water = 'TechnicalData_BaseData_Water',
  TechnicalData_BaseData_Heating = 'TechnicalData_BaseData_Heating',

  TechnicalData_MeterData_Power = 'TechnicalData_MeterData_Power',
  TechnicalData_MeterData_Gas = 'TechnicalData_MeterData_Gas',
  TechnicalData_MeterData_Water = 'TechnicalData_MeterData_Water',
  TechnicalData_MeterData_Heating = 'TechnicalData_MeterData_Heating',

  TechnicalData_ConfirmChimenySweeper_Power = 'TechnicalData_ConfirmChimenySweeper_Power',
  TechnicalData_ConfirmChimenySweeper_Gas = 'TechnicalData_ConfirmChimenySweeper_Gas',
  TechnicalData_ConfirmChimenySweeper_Water = 'TechnicalData_ConfirmChimenySweeper_Water',
  TechnicalData_ConfirmChimenySweeper_Heating = 'TechnicalData_ConfirmChimenySweeper_Heating',

  TechnicalData_Media = 'TechnicalData_Media',
  TechnicalData_Media_Power = 'TechnicalData_Media_Power',
  TechnicalData_Media_Gas = 'TechnicalData_Media_Gas',
  TechnicalData_Media_Water = 'TechnicalData_Media_Water',
  TechnicalData_Media_Heating = 'TechnicalData_Media_Heating',

  TechnicalData_OldMeterData_Power = 'TechnicalData_OldMeterData_Power',
  TechnicalData_OldMeterData_Gas = 'TechnicalData_OldMeterData_Gas',
  TechnicalData_OldMeterData_Water = 'TechnicalData_OldMeterData_Water',
  TechnicalData_OldMeterData_Heating = 'TechnicalData_OldMeterData_Heating',
  TechnicalData_CombustionPlantInfo = 'TechnicalData_CombustionPlantInfo',
  TechnicalData_ExhaustSystemData = 'TechnicalData_ExhaustSystemData',
  TechnicalData_FireplaceAndVentilation = 'TechnicalData_FireplaceAndVentilation',
  TechnicalData_Releases = 'TechnicalData_Releases',
  TechnicalData_MeterInstallation = 'TechnicalData_MeterInstallation',
  TechnicalData_PowerConnection_Power = 'TechnicalData_PowerConnection_Power',
  TechnicalData_PowerConnection_Gas = 'TechnicalData_PowerConnection_Gas',
  TechnicalData_PowerConnection_Water = 'TechnicalData_PowerConnection_Water',
  TechnicalData_PowerConnection_Heating = 'TechnicalData_PowerConnection_Heating',
  TechnicalData_SystemType = 'TechnicalData_SystemType',
  TechnicalData_SystemOperation = 'TechnicalData_SystemOperation',
  TechnicalData_MeasuringConcept = 'TechnicalData_MeasuringConcept',
  TechnicalData_Installation = 'TechnicalData_Installation',
}

export enum SectionStatus {
  none = 'None',
  approved = 'Approved',
  rejected = 'Rejected',
}

export class SectionMessage {
  id: number;
  content: string;
  application_id: number;
  section: SectionIdentifier;
  author: string;
  author_id: number;
  created_on: Date;
  role: string;
  title: string;
}

export class CreateSectionMessage {
  content: string;
  application_id: number;
  section: SectionIdentifier;
}

export class CreateSectionReview {
  application_id: number;
  section: SectionIdentifier;
  status: SectionStatus;
}

export class SectionReview {
  id: number;
  application_id: number;
  section: SectionIdentifier;
  status: SectionStatus;
  reviewer_id: number;
  reviewed_on: Date;
}

export enum SkExecutorAction {
  validate_application = 'validate_application',
  accept_application = 'accept_application',
  create_offer = 'create_offer',
  approve_offer = 'approve_offer',
  submit_offer = 'submit_offer',
  accept_offer = 'accept_offer',
  create_order = 'create_order',
  submit_order = 'submit_order',
  approve_order = 'approve_order',
  submit_order_to_sap = 'submit_order_to_sap',
  create_invoice = 'create_invoice',
  approve_invoice = 'approve_invoice',
  submit_invoice = 'submit_invoice',
  pay_invoice = 'pay_invoice',
  confirm_payment = 'confirm_payment',
  close_order_process = 'close_order_process',
  none = 'none',
  reject_offer = 'reject_offer',
  application_accepted = 'application_accepted',
  application_rejected = 'application_rejected',
  cs_accept_application = 'cs_accept_application',
  cs_reject_application = 'cs_reject_application',
  cs_application_accepted = 'cs_application_accepted',
  cs_application_rejected = 'cs_application_rejected',
  request_update_application = 'request_update_application',
  update_application = 'update_application',
}

export interface ShowButtonsPredicateContext {
  component: ReviewSectionComponent;
  orderProcess: any;
  userRole: string;
}
